export default {"src":"/_next/static/media/glob.58d7d2f7.svg","height":78,"width":78,"blurWidth":0,"blurHeight":0};